import request from '@/utils/request'


// 查询优惠券使用记录列表
export function listCouponUseRecord(query) {
  return request({
    url: '/biz/admin/activity/coupon/use/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询优惠券使用记录分页
export function pageCouponUseRecord(query) {
  return request({
    url: '/biz/admin/activity/coupon/use/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询优惠券使用记录详细
export function getCouponUseRecord(data) {
  return request({
    url: '/biz/admin/activity/coupon/use/record/detail',
    method: 'get',
    params: data
  })
}

// 新增优惠券使用记录
export function addCouponUseRecord(data) {
  return request({
    url: '/biz/admin/activity/coupon/use/record/add',
    method: 'post',
    data: data
  })
}

// 修改优惠券使用记录
export function updateCouponUseRecord(data) {
  return request({
    url: '/biz/admin/activity/coupon/use/record/edit',
    method: 'post',
    data: data
  })
}

// 删除优惠券使用记录
export function delCouponUseRecord(data) {
  return request({
    url: '/biz/admin/activity/coupon/use/record/delete',
    method: 'post',
    data: data
  })
}
